import { __assign, __rest } from "tslib";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import InternalContainer from "../container/internal";
import React from "react";
export var ExpandableSectionContainer = function(_a) {
    var className = _a.className, children = _a.children, header = _a.header, variant = _a.variant, expanded = _a.expanded, disableContentPaddings = _a.disableContentPaddings, __internalRootRef = _a.__internalRootRef, rest = __rest(_a, [
        "className",
        "children",
        "header",
        "variant",
        "expanded",
        "disableContentPaddings",
        "__internalRootRef"
    ]);
    if (variant === "container") {
        return /*#__PURE__*/ React.createElement(InternalContainer, __assign({}, rest, {
            className: className,
            header: header,
            variant: "default",
            disableContentPaddings: disableContentPaddings || !expanded,
            disableHeaderPaddings: true,
            __hiddenContent: !expanded,
            __internalRootRef: __internalRootRef
        }), children);
    }
    return /*#__PURE__*/ React.createElement("div", __assign({
        className: className
    }, rest, {
        ref: __internalRootRef
    }), header, children);
}; //# sourceMappingURL=expandable-section-container.js.map
